import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import CalendarTime from 'containers/CalendarTime/CalendarTimeContainer';
import CallButtons from 'containers/CallButtons/CallButtonsContainer';
import classes from './CalendarEvent.module.scss';

const CalendarEvent = (props) => {
  const {
    currentDay,
    event,
    extension,
    hasUpcomingTime,
    selectEvent,
    targetDay,
    title,
    totalDays
  } = props;

  return (
    <div
      className={[classes.container, hasUpcomingTime ? classes.upcoming : ''].join(' ')}
      onClick={selectEvent}
      data-testid='calendar-event'
    >
      <div className={classes.infoSection}>
        <div className={classes.title}>
          {title} {!!totalDays &&
          <FormattedMessage
            id="components.calendarEvent.dayOf"
            defaultMessage="(Day {currentDay}/{totalDays})"
            values={{
              currentDay,
              totalDays
            }}
          />}
        </div>
        <CalendarTime
          event={event}
          showUpcomingMsg={true}
          targetDay={targetDay}
        />
      </div>
      {extension && <div className={classes.callButtons}>
        <CallButtons extension={extension} />
      </div>}
    </div>
  );
};

CalendarEvent.propTypes = {
  currentDay: PT.number,
  event: PT.object,
  extension: PT.string,
  hasUpcomingTime: PT.bool,
  selectEvent: PT.func,
  targetDay: PT.object,
  title: PT.string,
  totalDays: PT.number
};

export default CalendarEvent;
